import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CountdownComponent } from 'ngx-countdown';
import { Utility } from 'src/app/common/utility';
import { DataService } from 'src/app/services/data.service';
import { StoreService } from 'src/app/services/store.service';
import { ToolsService } from 'src/app/services/tools.service';
import { BaseComponent } from '../base-components/base-component';

@Component({
  selector: 'app-scan-bar-code',
  templateUrl: './scan-bar-code.component.html',
  styleUrls: ['./scan-bar-code.component.scss']
})
export class ScanBarCodeComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChild('barCodeInput') barCodeInput: ElementRef;
  @ViewChild('timerModalLink') timerModalLink: ElementRef;
  @ViewChild(CountdownComponent) cd1: CountdownComponent;
  private timeout: any;
  constructor(
    dataService: DataService,
    storeService: StoreService,
    toolsService: ToolsService,
    activatedRoute: ActivatedRoute,
    router: Router
  ) {
    super(dataService, storeService, toolsService, activatedRoute, router);
  }
  ngAfterViewInit(): void {
    if (this.barCodeInput != undefined) {
      this.barCodeInput.nativeElement.focus();
    }
  }

  private isManualScan: Boolean = false;
  private scanComplete: Boolean = false;
  scanData: string;
  ngOnInit() {
    this.watchRouteParams();
    this.isManualScan = this.storeService.kioskSettings.disableScanOption;

  }

  PrintSecondaryTemplate() {
    let barcodeNumber = this.barCodeInput.nativeElement.value;
    if (barcodeNumber.length > 0) {
      let postData = { "barcode": barcodeNumber, "registerId": this.registerId };
      this.dataService.post<any>(`/Checkout/PrintSecondaryTemplate`, postData)
        .then(response => {
          response.data.succeeded = response.data.isSuccess;
          this.scanData = "";
          this.barCodeInput.nativeElement.value = "";
          this.toolsService.ProcessHttpResponse(response.data, () => {
            this.toolsService.showSuccess("Ticket printed succeessfully")
          });
        });
    }
  }

  gotToDashBoard() {
    if (this.registerId) {

      if (this.kioskId) {
        this.router.navigate([`/dashboard/${this.registerId}/${this.kioskId}`]);
      } else {
        this.router.navigate([`/dashboard/${this.registerId}`]);
      }

    }
  }

  onScanBlur() {
    this.barCodeInput.nativeElement.focus();
  }

  onNotify(event) {
    const self = this;

    if (event === 15000) {
      self.timerModalLink.nativeElement.click();
    } else if (event === 1000) {
      self.timeout = setTimeout(async () => {
        self.timerModalLink.nativeElement.click();
        await self.cancelOrder();
      }, 1000);
    }
  }

  cancelTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  @HostListener('click', ['$event.target']) onClick(ctrl) {
    // don't reset the timer why we programmatically click the link to show/hide the timer dialog
    if (ctrl.dataset.target !== '#timer-modal') {
      this.cd1.restart();
    }
  }

  @HostListener('keydown') onKeyDown() {
    this.cd1.restart();
  }

  async cancelOrder() {
    const self = this;
    await Utility.clearSessionCart(self.storeService, self.dataService, self.toolsService);
    if (self.registerId) {
      if (self.kioskId) {
        self.router.navigate([`/dashboard/${self.registerId}/${self.kioskId}`]);
      } else {
        self.router.navigate([`/dashboard/${self.registerId}`]);
      }
    }
  }


}
